import { UserBodyDtoRole } from '@api/WhisApi/generated/model/userBodyDtoRole';
import { TabItem, TabName } from './navBar.types';

/**
 * Main tabs (first 4) for desktop navigation.
 */
export const mainTabs: TabItem[] = [
  {
    name: TabName.board,
    labelKey: 'navigation.board',
    iconName: 'map-outline',
  },
  {
    name: TabName.reports,
    labelKey: 'navigation.myReports',
    iconName: 'document-text-outline',
  },
  {
    name: TabName.reportCreation,
    labelKey: 'navigation.addReport',
    iconName: 'add-circle-sharp',
    hiddenFrom: [UserBodyDtoRole.adminViewOnly],
  },
  {
    name: TabName.resources,
    labelKey: 'navigation.resources',
    iconName: 'grid-outline',
  },
];

/**
 * User management tab (web only).
 */
export const userManagementTab: TabItem = {
  name: TabName.userManagement,
  labelKey: 'navigation.userManagement',
  iconName: 'people-outline',
  visibleTo: [
    UserBodyDtoRole.admin,
    UserBodyDtoRole.delegate,
    UserBodyDtoRole.adminViewOnly,
  ],
};

/**
 * Notifications tab.
 */
export const notificationsTab: TabItem = {
  name: TabName.notifications,
  labelKey: 'navigation.alerts',
  iconName: 'notifications-outline',
};

/**
 * Profile tab.
 */
export const profileTab: TabItem = {
  name: TabName.profile,
  labelKey: 'navigation.profile',
  iconName: 'person-circle-outline',
};

/**
 * Array of tab configurations in display order.
 */
export const getMainTabs = ({
  isWeb = false,
  isSmallScreen = true,
}: { isWeb?: boolean; isSmallScreen?: boolean } = {}): TabItem[] => {
  const tabs = [...mainTabs];

  if (isWeb && !isSmallScreen) {
    tabs.push(userManagementTab);
  }

  return tabs;
};

export const getTabItems = ({
  isWeb = false,
  isSmallScreen = true,
}: { isWeb?: boolean; isSmallScreen?: boolean } = {}): TabItem[] => {
  return [...getMainTabs({ isWeb, isSmallScreen }), profileTab];
};
